

export const ApiKey = {
    Login: "connect/token",
    Inventory: "/inventoryDto",
    InventoryCost:"/inventoryCostDto",
    loginKey: "/authentication/login",
    TableDetails:"/tableDetailsDto",
    MappingDetails:"/tableDetailsDto/tableMapping",
    OrderDetails:"/orderDetail",
    Discount:"/discountDto",
    BillDetails:"/billingDto",
    User:"/userDto",
    Role:"/roleDto",
    Table:"/tableMaterDto",
    RestaurantProfile:"/restaurant-profile",
    ResetPassword:"/reset-password",
    Report:"/reportDto/sold-report",
    DeleteBillDetails:"/billingDto/orderId",
  };
  